import React from 'react';

const Placeholder = ({ size = 'small' }) => {
  return <div className={'app-placeholder app-placeholder--' + size}></div>;
};

export default Placeholder;
